import styled from "styled-components";
import { VeryModal } from "../../common/v2/VeryModal";

const Modal = styled(VeryModal)`
  .divContentModal {
    width: 480px;
  }
  .divBodyModal {
    align-items: flex-start !important;
    gap: 14px;
    padding: 0px 3px 3px 3px;
    .div-durationOptions {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 8px;
      width: 100%;
    }
    .btn-duration {
      border: 1.5px solid #e0e0e0;
      border-radius: 8px;
      padding: 7px 16px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      color: #444;
      background: #fafafa;
      transition: all 0.15s;
      &.selected {
        border-color: #222;
        background: #222;
        color: #fff;
      }
      &:hover:not(.selected) {
        border-color: #999;
        background: #f0f0f0;
      }
    }
    .txt-label {
      font-size: 13px;
      font-weight: 600;
      color: #444;
      margin-bottom: -4px;
    }
  }
  .divButtons .btnModal {
    padding-top: 11px;
    padding-bottom: 11px;
    border-radius: 10px;
  }
`;

const Styles = { Modal };

export default Styles;
